// extracted by mini-css-extract-plugin
export default {"container":"ProjectArchive_container__cFk-N","card_container":"ProjectArchive_card_container__c1wwc"};